export default __webpack_public_path__ + "static/media/jdManagementIcon.2a545e88.svg";